import { FormattedMessage } from 'react-intl';

interface Props {
  onMouseUp: (event: React.MouseEvent) => void;
  count: number;
}

export const LoadPending: React.FC<Props> = ({ onMouseUp, count }) => {
  return (
    <button className='load-more load-gap' onMouseUp={onMouseUp} type='button'>
      <FormattedMessage
        id='load_pending'
        defaultMessage='{count, plural, one {# new item} other {# new items}}'
        values={{ count }}
      />
    </button>
  );
};
